import { Pipe, PipeTransform } from '@angular/core';
import { BehaviorScreen } from '../models/view-models/monitor-models/screen.type';
import { MonitorSortEnum } from '../enums/monitor-sort.enum';

@Pipe({
  name: 'monitorSort'
})
export class MonitorSortPipe implements PipeTransform {

  transform(monitors: Partial<BehaviorScreen>[], sortByFieldName: string): Partial<BehaviorScreen>[] {
    if (!monitors) {
      return monitors;
    }

    return monitors.sort((a: BehaviorScreen, b: BehaviorScreen): number => {
      let result = 0;

      switch (sortByFieldName) {
        case MonitorSortEnum.SortByMonitorTitle:
          result = a[sortByFieldName].localeCompare(b[sortByFieldName], undefined, {numeric: true, sensitivity: 'base'});
          break;

        case MonitorSortEnum.SortByLocationTitle:
          result = a.Machine[sortByFieldName].localeCompare(b.Machine[sortByFieldName], undefined, {numeric: true, sensitivity: 'base'});
          break;
      }

      return result;
    });
  }
}
